import type * as ModelType from "@/components/features/faq/model/type";

type SubCategory = {
	name: string;
	categoryName: string;
};

/**
 *
 * @description contents から categoryName + subcategoryName を key として、unique な subcategoryNames を返す
 *
 * @param contents {Array<ModelType.Content>}
 *
 * @returns {Array<SubCategory>}
 *
 */
export const uniqueSubCategoriesFilter = (contents: Array<ModelType.Content>): Array<SubCategory> => {
	const uniqueSubcategoryMap = new Map<string, { name: string; categoryName: string }>();
	// contents から subcategory を取り出し、重複を排除する
	for (const content of contents) {
		// unique key = subcategory name
		uniqueSubcategoryMap.set(`${content.categoryName}-${content.subcategoryName}`, {
			name: content.subcategoryName,
			categoryName: content.categoryName,
		});
	}

	const subcategories: Array<SubCategory> = [];
	for (const subcategory of uniqueSubcategoryMap.values()) {
		subcategories.push(subcategory);
	}

	return subcategories;
};
